// 系统管理

import request from '@/utils/request'
// 获取税率
export function QueryTaxRateConfig(data) {
  return request({
    url: 'TaxRate/QueryTaxRateConfig',
    method: 'get',
    params: data
  })
}
// 修改税率
export function UpdateTaxRateConfig(data) {
  return request({
    url: 'TaxRate/UpdateTaxRateConfig',
    method: 'post',
    data: data
  })
}
// 获取仓库列表
export function GetWarehouseFullList(data) {
  return request({
    url: 'Warehouse/GetWarehouseFullList',
    method: 'get',
    params: data
  })
}
// 库存同步
export function ResyncWarehouse(data) {
  return request({
    url: 'Warehouse/ResyncWarehouse',
    method: 'get',
    params: data
  })
}

// 编辑
export function UpdateWarehouseInfo(data) {
  return request({
    url: 'Warehouse/UpdateWarehouseInfo',
    method: 'post',
    data: data
  })
}

// 白名单列表
export function GetWhiteList(data) {
  return request({
    url: 'WhiteList/GetWhiteList',
    method: 'get',
    params: data
  })
}

// 加入白名单
export function AddToWhiteList(data) {
  return request({
    url: 'WhiteList/AddToWhiteList',
    method: 'post',
    data: data
  })
}

// 删除白名单
export function DeleteFromWhiteList(data) {
  return request({
    url: 'WhiteList/DeleteFromWhiteList',
    method: 'post',
    data: data
  })
}

// 黑名单列表
export function GetBlackList(data) {
  return request({
    url: 'WhiteList/GetBlackList',
    method: 'get',
    params: data
  })
}

// 加入黑名单
export function AddToBlackList(data) {
  return request({
    url: 'WhiteList/AddToBlackList',
    method: 'post',
    data: data
  })
}

// 删除黑名单
export function DeleteFromBlackList(data) {
  return request({
    url: 'WhiteList/DeleteFromBlackList',
    method: 'post',
    data: data
  })
}

// 操作履历
export function GetHistoryByOperation(data) {
  return request({
    url: 'WhiteList/GetHistoryByOperation',
    method: 'get',
    params: data
  })
}

// 仓库列表
export function GetLogisticsStopWarehouseList(data) {
  return request({
    url: 'Warehouse/GetLogisticsStopWarehouseList',
    method: 'get',
    params: data
  })
}

// 仓库物流停运列表
export function QueryLogisticsStopAreaList(data) {
  return request({
    url: 'Warehouse/QueryLogisticsStopAreaList',
    method: 'get',
    params: data
  })
}

// 更新物流停运
export function AddLogisticsStopArea(data) {
  return request({
    url: 'Warehouse/AddLogisticsStopArea',
    method: 'post',
    data: data
  })
}

// 修改物流停运
export function UpdateLogisticsStopArea(data) {
  return request({
    url: 'Warehouse/UpdateLogisticsStopArea',
    method: 'post',
    data: data
  })
}
// 停启用物流停运
export function SetLogisticsStopArea(data) {
  return request({
    url: 'erp/Logistics/SetLogisticsStopArea',
    method: 'post',
    data: data
  })
}

// 删除物流停运
export function DelLogisticsStopArea(data) {
  return request({
    url: 'erp/Logistics/DelLogisticsStopArea',
    method: 'post',
    data: data
  })
}

// 修改调拨配置
export function QueryWarehouseAllocationConfig(data) {
  return request({
    url: 'Warehouse/QueryWarehouseAllocationConfig',
    method: 'get',
    params: data
  })
}
// 保存调拨配置

export function SaveWarehouseAllocationConfig(data) {
  return request({
    url: 'Warehouse/SaveWarehouseAllocationConfig',
    method: 'post',
    data: data
  })
}
// 获取所有functions
export function GetAllFunctions(data) {
  return request({
    url: 'SupplierLogin/GetAllFunctions',
    method: 'get',
    params: data
  })
}
// 新增组件
export function AddPageFunction(data) {
  return request({
    url: 'SupplierLogin/AddPageFunction',
    method: 'post',
    data: data
  })
}
// 修改组件
export function UpdatePageFunction(data) {
  return request({
    url: 'SupplierLogin/UpdatePageFunction',
    method: 'post',
    data: data
  })
}
// 删除组件
export function DeletePageFunction(data) {
  return request({
    url: 'SupplierLogin/DeletePageFunction',
    method: 'post',
    data: data
  })
}
// 获取角色List
export function GetRoleList(data) {
  return request({
    url: 'UserRole/GetRoleList',
    method: 'get',
    params: data
  })
}
// 获取角色详情
export function GetRoleInfoByCode(data) {
  return request({
    url: 'UserRole/GetRoleInfoByCode',
    method: 'get',
    params: data
  })
}
// 删除角色详情
export function DeleteRole(data) {
  return request({
    url: 'UserRole/DeleteRole',
    method: 'post',
    data: data
  })
}
// 保存角色详情
export function SaveRole(data) {
  return request({
    url: 'UserRole/SaveRole',
    method: 'post',
    data: data
  })
}
// 获取用户列表
export function GetUserList(data) {
  return request({
    url: 'UserRole/GetUserList',
    method: 'get',
    params: data
  })
}
// 获取用户详情
export function GetUserInfoById(data) {
  return request({
    url: 'UserRole/GetUserInfoById',
    method: 'get',
    params: data
  })
}

// 保存用户信息
export function SaveUser(data) {
  return request({
    url: 'UserRole/SaveUser',
    method: 'post',
    data: data
  })
}

// 用户账号禁用
export function DisableUser(data) {
  return request({
    url: 'UserRole/DisableUser',
    method: 'post',
    data: data
  })
}

// 获取角色树
export function GetRoleTree(data) {
  return request({
    url: 'UserRole/GetRoleTree',
    method: 'get',
    params: data
  })
}

// 获取店铺树
export function GetShopTree(data) {
  return request({
    url: 'UserRole/GetShopTree',
    method: 'get',
    params: data
  })
}
// 获取品牌树
export function GetBrandTree(data) {
  return request({
    url: 'UserRole/GetBrandTree',
    method: 'get',
    params: data
  })
}

// 反查
export function GetUserListByCondition(data) {
  return request({
    url: 'UserRole/GetUserListByCondition',
    method: 'get',
    params: data
  })
}
export function GetRoleListByCondition(data) {
  return request({
    url: 'UserRole/GetRoleListByCondition',
    method: 'get',
    params: data
  })
}

// 店铺管理
export function GetShopList(data) {
  return request({
    url: 'Shop/GetShopList',
    method: 'get',
    params: data
  })
}

// 店铺管理编辑
export function UpdateShopInfo(data) {
  return request({
    url: 'Shop/UpdateShopInfo',
    method: 'post',
    data: data
  })
}

// 客户编码对照/仓库编码对照 mapping_type=0/1
export function GetFsystemCodeMappingList(data) {
  return request({
    url: 'FinancialProcess/GetFsystemCodeMappingList',
    method: 'get',
    params: data
  })
}

// 新增编码
export function AddFsysMapping(data) {
  return request({
    url: 'FinancialProcess/AddFsysMapping',
    method: 'post',
    data: data
  })
}

// 编辑编码
export function UpdateFsysMapping(data) {
  return request({
    url: 'FinancialProcess/UpdateFsysMapping',
    method: 'post',
    data: data
  })
}

// 查询字段配置
export function GetListFieldConf(data) {
  return request({
    url: 'ListFieldConf/GetListFieldConf',
    method: 'get',
    params: data
  })
}

// 查询字段配置详情
export function GetListFieldconfdetail(data) {
  return request({
    url: 'ListFieldConf/GetListFieldconfdetail',
    method: 'get',
    params: data
  })
}

// 保存字段配置
export function SaveMasterTable(data) {
  return request({
    url: 'ListFieldConf/SaveMasterTable',
    method: 'post',
    data: data
  })
}
// 店铺管理同步
export function SyncShopData(data) {
  return request({
    url: 'shop/SyncShopData',
    method: 'post',
    data: data
  })
}
// 财务编码店铺接口
export function GetShopListProcess(data) {
  return request({
    url: 'FinancialProcess/GetShopList',
    method: 'get',
    params: data
  })
}
// 仓库编码list接口
export function GetWarehouseFullListProcess(data) {
  return request({
    url: 'FinancialProcess/GetWarehouseFullList',
    method: 'get',
    params: data
  })
}
// 仓库管理是否推送nc
export function PushWarehouseData(data) {
  return request({
    url: 'Warehouse/PushWarehouseData',
    method: 'post',
    data: data
  })
}
// 所属公司得接口
export function GetCompnyData(data) {
  return request({
    url: 'Warehouse/GetCompnyData',
    method: 'get',
    params: data
  })
}
// nc仓库编码
export function WarehouseNoIsExist(data) {
  return request({
    url: 'Warehouse/WarehouseNoIsExist',
    method: 'get',
    params: data
  })
}
// 获取黑名单类型
export function GetBlackType(data) {
  return request({
    url: 'WhiteList/GetBlackType',
    method: 'get',
    params: data
  })
}

// 更新黑名单的停运标记
export function UpdateBlackList(data) {
  return request({
    url: 'WhiteList/UpdateBlackList',
    method: 'post',
    data: data
  })
}
// 获取UAT用户大列表
export function GetUATUserList(data) {
  return request({
    url: 'UATRole/GetUATUserList',
    method: 'get',
    params: data
  })
}
// 查询UAT角色列表
export function GetRoleListForUAT(data) {
  return request({
    url: 'UATRole/GetRoleListForUAT',
    method: 'get',
    params: data
  })
}
// 查询UAT用户列表
export function GetUserListForUAT(data) {
  return request({
    url: 'UATRole/GetUserListForUAT',
    method: 'get',
    params: data
  })
}
// 保存UAT权限用户
export function SaveUATRole(data) {
  return request({
    url: 'UATRole/SaveUATRole',
    method: 'post',
    data: data
  })
}
// 删除UAT用户
export function DeleteUATRole(data) {
  return request({
    url: 'UATRole/DeleteUATRole',
    method: 'get',
    params: data
  })
}

// 查看菜单list
export function GetFunctionByParentID(data) {
  return request({
    url: 'SupplierLogin/GetFunctionByParentID',
    method: 'get',
    params: data
  })
}

// 删除菜单list
export function DeleteFunction(data) {
  return request({
    url: 'SupplierLogin/DeleteFunction?id=' + data.id,
    method: 'post'
  })
}

// 保存菜单list
export function SaveFunctionInfo(data) {
  return request({
    url: 'SupplierLogin/SaveFunctionInfo',
    method: 'post',
    data: data
  })
}

// 解锁
export function EnableUserLogin(data) {
  return request({
    url: 'UserRole/EnableUserLogin',
    method: 'post',
    data: data
  })
}

// 查询工具列表
export function GetSearchToolList(data) {
  return request({
    url: 'SearchTool/GetSearchToolList',
    method: 'get',
    params: data
  })
}
// 新增查询
export function AddSearchTool(data) {
  return request({
    url: 'SearchTool/AddSearchTool',
    method: 'post',
    data
  })
}

// 编辑查询
export function EditSearchTool(data) {
  return request({
    url: 'SearchTool/EditSearchTool',
    method: 'post',
    data
  })
}

// 停用查询
export function StopSearchTool(data) {
  return request({
    url: 'SearchTool/StopSearchTool',
    method: 'post',
    data
  })
}
// 启用查询
export function StartSearchTool(data) {
  return request({
    url: 'SearchTool/StartSearchTool',
    method: 'post',
    data
  })
}
//  删除查询
export function DeleteSearchTool(data) {
  return request({
    url: 'SearchTool/DeleteSearchTool',
    method: 'post',
    data
  })
}

// 查询列表数据(分页)
export function GetDataSourcelist(data) {
  return request({
    url: 'SearchTool/GetDataSourcelist',
    method: 'get',
    params: data
  })
}
// 查询工具参数明细
export function GetSearchToolParamList(data) {
  return request({
    url: 'SearchTool/GetSearchToolParamList',
    method: 'get',
    params: data
  })
}
// 修改数据
export function UpdateDataSource(data) {
  return request({
    url: 'SearchTool/UpdateDataSource',
    method: 'post',
    data
  })
}

// 删除数据
export function DeleteDataSource(data) {
  return request({
    url: 'SearchTool/DeleteDataSource',
    method: 'post',
    data
  })
}

// 新增数据
export function AddDataSource(data) {
  return request({
    url: 'SearchTool/AddDataSource',
    method: 'post',
    data
  })
}
// 获取查询名称
export function GetSearchToolFunctionParamList(data) {
  return request({
    url: 'SearchTool/GetSearchToolFunctionParamList',
    method: 'get',
    params: data
  })
}
// 查看数据源是否在使用
export function GetSearchToolDataSourceUseList(data) {
  return request({
    url: 'SearchTool/GetSearchToolDataSourceUseList',
    method: 'get',
    params: data
  })
}

// 通用初始化页面
export function GetSearchToolPageElement(data) {
  return request({
    url: 'SearchTool/GetSearchToolPageElement',
    method: 'get',
    params: data
  })
}

// 导出，获取列表数据
// 角色下用户
// 历史导出记录
export function ExecuteSearchToolInstance(data) {
  return request({
    url: 'SearchTool/ExecuteSearchToolInstance',
    method: 'get',
    params: data
  })
}

// 获取下拉框数据
export function EexcuteDataSource(data) {
  return request({
    url: 'SearchTool/EexcuteDataSource',
    method: 'get',
    params: data
  })
}

// 初始化参数列表
export function InitParamFromSqlInfo(data) {
  return request({
    url: 'SearchTool/InitParamFromSqlInfo',
    method: 'get',
    params: data
  })
}

// 查询预警列表数据
export function GetWarningPageProcessinglist(data) {
  return request({
    url: 'WarningPage/GetWarningPageProcessingPagelist',
    method: 'get',
    params: data
  })
}
// 初始化
export function GetPropertyByAPIName(data) {
  return request({
    url: 'SearchTool/GetPropertyByAPIName',
    method: 'get',
    params: data
  })
}

// 查询单个预警信息
export function GetSingleWarningPageProcessingInfo(data) {
  return request({
    url: 'WarningPage/GetSingleWarningPageProcessingInfo',
    method: 'get',
    params: data
  })
}

// 批量处理预警（新增）
export function AddWarningInfoByBacth(data) {
  return request({
    url: 'WarningPage/AddWarningInfoByBacth',
    method: 'post',
    data
  })
}

// 预警编辑接口
export function UpdateWarningInfo(data) {
  return request({
    url: 'WarningPage/UpdateWarningInfo',
    method: 'post',
    data
  })
}

// 复制用户
export function CopyUserInfoById(data) {
  return request({
    url: 'UserManage/CopyUserInfoById',
    method: 'post',
    data: data
  })
}

// 重置用户密码
export function ResetUserPWD(data) {
  return request({
    url: 'UserManage/ResetUserPWD',
    method: 'post',
    data: data
  })
}
// 右键临时执行预警
export function ExecuteWarningTaskByID(data) {
  return request({
    url: 'WarningPage/ExecuteWarningTaskByID',
    method: 'post',
    data
  })
}

// 新增页面控件
export function AddPageFunctionByReport(data) {
  return request({
    url: 'WarningPage/AddPageFunctionByReport',
    method: 'post',
    data
  })
}

// 6、右击删除预警：
export function DeleteWarningInfo(data) {
  return request({
    url: 'WarningPage/DeleteWarningInfo',
    method: 'post',
    data
  })
}

// 7、查询页面右击临时预警功能：
export function ExecuteWarningTaskBySearchID(data) {
  return request({
    url: 'WarningPage/ExecuteWarningTaskBySearchID',
    method: 'post',
    data
  })
}

// 查询分组
export function GetSearchViewChartList(data) {
  return request({
    url: 'SearchViewChart/GetSearchViewChartList',
    method: 'get',
    params: data
  })
}

// 分组明细列表
export function GetCategoryCollectionList(data) {
  return request({
    url: 'SearchViewChart/GetCategoryCollectionList',
    method: 'get',
    params: data
  })
}

// 新增父级接口
export function AddReportCategory(data) {
  return request({
    url: 'SearchTool/AddReportCategory',
    method: 'post',
    data
  })
}

// 新增子级接口
export function AddReportCategoryDetail(data) {
  return request({
    url: 'SearchTool/AddReportCategoryDetail',
    method: 'post',
    data
  })
}

// 预览图表接口
export function GetViewChartByParam(data) {
  return request({
    url: 'SearchViewChart/GetViewChartByParam',
    method: 'post',
    data
  })
}

// 通用图表查询
export function GetViewChartDataBySearchID(data) {
  return request({
    url: 'SearchViewChart/GetViewChartDataBySearchID',
    method: 'get',
    params: data
  })
}

// 修改分组
export function UpdateReportCategory(data) {
  return request({
    url: 'SearchTool/UpdateReportCategory',
    method: 'post',
    data
  })
}

// 删除分组
export function DeleteReportCategory(data) {
  return request({
    url: 'SearchTool/DeleteReportCategory',
    method: 'post',
    data
  })
}

// 修改子级控件
export function UpdateReportCategoryDetail(data) {
  return request({
    url: 'SearchTool/UpdateReportCategoryDetail',
    method: 'post',
    data
  })
}

// 删除子级控件
export function DeleteReportCategoryDetail(data) {
  return request({
    url: 'SearchTool/DeleteReportCategoryDetail',
    method: 'post',
    data
  })
}

// 获取子级控件信息
export function GetReportCategoryDetail(data) {
  return request({
    url: 'SearchTool/GetReportCategoryDetail',
    method: 'get',
    params: data
  })
}

// 获取表头信息
export function GetDropDownList(data) {
  return request({
    url: 'SearchViewChart/GetDropDownList',
    method: 'get',
    params: data
  })
}

// 获取图表信息（用于编辑）
export function GetViewChartDataByChartID(data) {
  return request({
    url: 'SearchViewChart/GetViewChartDataByChartID',
    method: 'get',
    params: data
  })
}

// 试发送
export function TrySendMessage(data) {
  return request({
    url: 'SearchTool/TrySendMessage',
    method: 'post',
    data
  })
}

// 页面列表
// 查询
export function GetCombPageFunctionList(data) {
  return request({
    url: 'CombPageFunction/GetCombPageFunctionList',
    method: 'get',
    params: data
  })
}
// 查询生成页面明细
export function GetCombPageFunctionByID(data) {
  return request({
    url: 'CombPageFunction/GetCombPageFunctionByID',
    method: 'get',
    params: data
  })
}

// 更新生成页面
export function UpdateCombPageFunction(data) {
  return request({
    url: 'CombPageFunction/UpdateCombPageFunction',
    method: 'post',
    data
  })
}

// 新增生成页面
export function AddCombPageFunction(data) {
  return request({
    url: 'CombPageFunction/AddCombPageFunction',
    method: 'post',
    data
  })
}

// 删除生成页面
export function DeleteCombPageFunction(data) {
  return request({
    url: 'CombPageFunction/DeleteCombPageFunction',
    method: 'post',
    data
  })
}

// 生成页面查询分组父级列表过滤已选分组
export function GetCategoryMasterDataList(data) {
  return request({
    url: 'CombPageFunction/GetCategoryMasterDataList',
    method: 'get',
    params: data
  })
}

// 查询父级路由列表
export function GetParentRouterList(data) {
  return request({
    url: 'CombPageFunction/GetParentRouterList',
    method: 'get',
    params: data
  })
}

// 查询系统操作日志
export function operation(data) {
  return request({
    url: 'ibs/UserBehavior/operation',
    method: 'get',
    params: data
  })
}

// 获取项目下拉列表
export function GetProjectDic(data) {
  return request({
    url: 'pms/ProjectMananent/GetProjectDic',
    method: 'get',
    params: data
  })
}

// 获取项目下的集合任务下拉列表
export function GetAggregateListByProject(data) {
  return request({
    url: 'pms/ProjectMananent/GetAggregateListByProject',
    method: 'get',
    params: data
  })
}
// 获取项目下的所有任务+里程碑
export function GetTaskDic(data) {
  return request({
    url: 'pms/ProjectMananent/GetTaskDic',
    method: 'get',
    params: data
  })
}
// 任务执行，执行完成，执行验收
export function ChangeTaskStatus(data) {
  return request({
    url: 'pms/ProjectMananent/ChangeTaskStatus',
    method: 'post',
    data
  })
}
// 删除任务
export function DeleteTask(data) {
  return request({
    url: 'pms/ProjectMananent/DeleteTask',
    method: 'get',
    params: data
  })
}

// 查看甘特图
export function GetGanttChartData(data) {
  return request({
    url: 'pms/GanttChart/GetGanttChartData',
    method: 'post',
    data
  })
}

// 获取仓库币种
export function GetWarehouseCurrency(data) {
  return request({
    url: 'Warehouse/GetWarehouseCurrency',
    method: 'get',
    params: data
  })
}

// 获取导出历史记录
export function GetExportTaskList(data) {
  return request({
    url: 'SearchTool/GetExportTaskList',
    method: 'get',
    params: data
  })
}

// 新增/批量新增、修改物流停运信息
export function SaveLogisticsStopArea(data) {
  return request({
    url: 'erp/Logistics/SaveLogisticsStopArea',
    method: 'post',
    data
  })
}
// 查询页面角色
export function GetRoleListByFunctionId(data) {
  return request({
    url: 'uias/PagePermission/GetRoleListByFunctionId',
    method: 'get',
    params: data
  })
}
// 查询用户角色/权限 申请列表
export function GetPermissionApplyBillList(data) {
  return request({
    url: 'uias/Permission/QueryPermissionApplyBillList',
    method: 'get',
    params: data
  })
}
// 查看用户申请
export function GetPermissionApplyBill(data) {
  return request({
    url: 'uias/Permission/GetPermissionApplyBill',
    method: 'get',
    params: data
  })
}
// 新增/编辑用户申请
export function SavePermissionApplyBill(data) {
  return request({
    url: 'uias/Permission/SavePermissionApplyBill',
    method: 'post',
    data
  })
}

// 用户权限导入（模板：UserPermissions）
// 配合 UploadTemplate 使用，入参：{ file_path }
export function ParseBrandNameExcel(data) {
  return request({
    url: 'sales/BrandNameImport/ParseBrandNameExcel',
    method: 'post',
    data
  })
}
// 提交审批
export function CreateApprovalFlow(data) {
  return request({
    url: 'uias/Permission/CreateApprovalFlow',
    method: 'post',
    data
  })
}
// 查询用户权限-默认信息
export function GetUserPermissionsByUserId(data) {
  return request({
    url: 'uias/Permission/GetUserPermissionsByUserId',
    method: 'get',
    params: data
  })
}

// 校验重复姓名
export function CheckUserName(data) {
  return request({
    url: 'uias/UserRole/CheckUserName',
    method: 'get',
    params: data
  })
}
// 查询当前用户的所有角色
export function GetRolesByUserId(data) {
  return request({
    url: 'uias/Permission/GetRolesByUserId',
    method: 'get',
    params: data
  })
}
// 查询角色权限-默认信息(角色下拉框联动信息)
export function GetRolePermissionsByUserId(data) {
  return request({
    url: 'uias/Permission/GetRolePermissionsByUserId',
    method: 'get',
    params: data
  })
}
// 查询变更用户权限-默认信息
export function GetChangeUserPermissionsByUserId(data) {
  return request({
    url: 'uias/Permission/GetChangeUserPermissionsByUserId',
    method: 'get',
    params: data
  })
}

// 下拉框-新增一个权限

export function GetSingleFunctionsAndElement(data) {
  return request({
    url: 'uias/UserRole/GetSingleFunctionsAndElement',
    method: 'get',
    params: data
  })
}

// 下拉框-新增一个仓库
export function GetWarehouseList(data) {
  return request({
    url: 'api/uias/UserRole/GetWarehouseList',
    method: 'get',
    params: data
  })
}
// 下拉框-新增一个可用价格
export function GetProductPriceList(data) {
  return request({
    url: 'uias/UserRole/GetProductPriceList',
    method: 'get',
    params: data
  })
}

// 添加阶梯
export function AddErpTieredPricingTemplate(data) {
  return request({
    url: 'erp/ErpTieredPricingTemplate/AddErpTieredPricingTemplate',
    method: 'post',
    data: data
  })
}
// 修改阶梯
export function EditErpTieredPricingTemplate(data) {
  return request({
    url: 'erp/ErpTieredPricingTemplate/EditErpTieredPricingTemplate',
    method: 'post',
    data: data
  })
}

// 删除阶梯
export function DelErpTieredPricingTemplate(data) {
  return request({
    url: 'erp/ErpTieredPricingTemplate/DelErpTieredPricingTemplate',
    method: 'post',
    data: data
  })
}
// 获取阶梯列表
export function getPageList(data) {
  return request({
    url: 'erp/Query/GetPageList',
    method: 'post',
    data: data
  })
}

// 审批流模板远程方法下拉列表
export function GetDropDownListHandle(data) {
  return request({
    url: 'approve/JJFlowTemplateRemoteInterface/GetDropDownList',
    method: 'get',
    params: data
  })
}

// 获取审批矩阵下拉
export function GetFlowMatrixDrowList() {
  return request({
    url: 'approve/JJFlowMatrix/GetFlowMatrixDrowList',
    method: 'get'
  })
}

// 获取审批矩阵字段下拉
export function GetFlowMatrixFieldDrowList(data) {
  return request({
    url: 'approve/JJFlowMatrix/GetFlowMatrixFieldDrowList',
    method: 'get',
    params: data
  })
}
// AmsWorkstation/bind 绑定用户与工位 (Auth)
export function bind(data) {
  return request({
    url: 'erp/AmsWorkstation/bind',
    method: 'post',
    data: data
  })
}

// AmsWorkstation/unbind 解绑工位 (Auth)
export function unbind(data) {
  return request({
    url: 'erp/AmsWorkstation/unbind',
    method: 'post',
    data: data
  })
}

// /AmsWorkstation/import  导入
export function amsWorkstationImport(data) {
  return request({
    url: 'erp/AmsWorkstation/import',
    method: 'post',
    data: data
  })
}

// AmsWorkstation/saveWorkstations  保存工位
export function saveWorkstations(data) {
  return request({
    url: 'erp/AmsWorkstation/saveWorkstations',
    method: 'post',
    data: data
  })
}
